import { Modal, Radio } from "antd";
import React, { useEffect, useReducer, useState } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";

const AdminCopyNewCourseModal = ({ children, courseId , setReFetch }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onTouched" });

  function reducer(state, action) {
    switch (action.type) {
      case "setSubmitCopyCourse": {
        return {
          ...state,
          submitCopyCourse: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitCopyCourse: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  //!--------- Add Copy -------

  const [copySuccess, copyErrors, submitLoading] = useAxios(
    process.env.REACT_APP_ADMIN_DEEP_CLONE_COURSE_API,
    "POST",
    state.submitCopyCourse.flag,
    state.submitCopyCourse.dependency,
    state.submitCopyCourse.data,
    true
  );

  const onSubmit = (data) => {
    const finalData = {
      course_id: courseId,
      ...data
    };
    dispatch({
      type: "setSubmitCopyCourse",
      payload: {
        flag: "submitCopyCourse",
        dependency: !state.submitCopyCourse.dependency,
        data: finalData,
      },
    });
  };

  useEffect(() => {
    if (copySuccess) {
      handleCancel();
      reset();
      if(setReFetch){
        setReFetch((prev) => !prev);
      }
    }
  }, [copySuccess]);

  return (
    <>
      <button onClick={showModal}>{children}</button>
      <Modal
        title=""
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        wrapClassName="examCopyModal"
        width={600}
        destroyOnClose
      >
        <h2 className="my-20 text-center text-3xl font-semibold">
          Please fill in the information to copy the course
        </h2>

        <form
          encType="multipart/form-data"
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className=" flex   flex-col items-start justify-center gap-10 rounded-3xl bg-blue-200 p-16 shadow-lg shadow-blue-200/50"
        >
          {/** Name stage filed */}
          <div className="flex w-full items-start justify-between gap-16 md:flex-col md:gap-10 ">
            <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">Name</label>
              <input
                className="signin-inputs w-full pl-4"
                type="text"
                id="name"
                placeholder="Name"
                name="name"
                autoComplete="on"
                {...register("name", {
                  required: true,
                  maxLength: 40,
                  minLength: 3,
                })}
              />
              {errors.name && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.name.type === "required" &&
                    "Please fill out this field"}
                  {errors.name.type === "maxLength" &&
                    "The maximum number of characters is 40 characters"}
                  {errors.name.type === "minLength" &&
                    "Please write at least 3 characters"}
                </p>
              )}
              {
                //!-------server errors -----

                copyErrors && copyErrors?.response?.data?.errors?.name && (
                  <p className="w-full  text-[12px] text-blue-900  ">
                    {copyErrors?.response?.data?.errors?.name[0]}
                  </p>
                )
              }
            </div>
          </div>

          <div className="flex items-center justify-end gap-5 mt-10">
            <button
              onClick={handleCancel}
              className="w-[100px] rounded-2xl border-2 border-accent bg-accent p-3 text-center font-semibold text-light duration-300 hover:bg-light hover:text-accent active:scale-90"
            >
              Cancel
            </button>
            <button
              disabled={
                !isValid || (submitLoading && state.submitCopyCourse.flag)
              }
              type="submit"
              className="w-[100px] rounded-2xl border-2 border-secondary bg-secondary p-3 text-center font-semibold text-light duration-300 hover:bg-light hover:text-secondary active:scale-90"
            >
              {submitLoading && state.submitCopyCourse.flag ? (
                <FontAwesomeIcon icon={faSpinner} spin />
              ) : (
                <p> Copy Course</p>
              )}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AdminCopyNewCourseModal;
